// extracted by mini-css-extract-plugin
export default {"select__value-container":"UserRole_select__value-container__1V+f3"};